import { invoke } from '@tauri-apps/api/core';
import { isTauri } from '../../utils/tauri';

/**
 * The sidebar footer's Retry (card 1.8): ask the sync engine for an immediate
 * pull + push of this bucket — the same `sync_pull_now` the vault banners and
 * the team realtime path use. A no-op outside the desktop app.
 */
export async function retrySync(workspaceId) {
  if (!workspaceId || !isTauri()) return;
  await invoke('sync_pull_now', { workspaceId }).catch(() => {});
}
